module.exports = __webpack_public_path__ + "img/其他调查-影像信息@2x.badd946b.jpg";